let PackagesItem = [
    {
        id: 2,
        trackTitle: "NO RECORDINGS access",
        trackSubtitle: "For Junior specialists",
        trackPrice: "299",
        trackNextPrice: "349",
        trackFullPrice: '500',
        trackButton: "Register",
        slack: 'Slack membership and certificate is also not included in no recordings package',
        vod: "No VODs access",
        trackLink: 'https://geekle.us/ticket/1679301430946x917822113925562400',
    },
    {
        id: 1,
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "349",
        trackFullPrice: '800',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Online stream access + Recordings',
        trackLink: 'https://geekle.us/ticket/1677238007884x465963308331302900',
    },
];

export default PackagesItem;
